import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Colors } from "../theme";

export const LoginContain = styled(Box)(() => ({
  backgroundColor: Colors.color,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  overflow: "hidden",
  "&::before, &::after": {
    content: '""',
    position: "fixed",
    width: "135px",
    height: "135px",
    borderRadius: "50%",
    backgroundColor: Colors.primary,
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    zIndex: 1,
  },
  "&::before": {
    bottom: "-70px",
    left: "-70px",
  },
  "&::after": {
    top: "-70px",
    right: "-70px",
  },
  "& .LoginLogo": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "500px",
    width: "100%",
    margin: "auto",
    "& img": {
      width: "60px",
    },
  },
  "& .LoginCard": {
    maxWidth: "500px",
    width: "100%",
    padding: "40px",
    backgroundcolor: Colors.text,
    borderRadius: "15px",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    border:"1px solid "+Colors.border,
    "& .LoginTitle": {
      marginBottom: "30px",
      "& h4": {
        fontSize: "28px",
        color: Colors.primary,
        textAlign: "center",
      },
      "& p": {
        textAlign: "center",
        fontSize: "14px",
        color: "gray",
      },
    },
    "& .LoginGroup": {
      marginBottom: "20px",
      "& label": {
        display: "block",
        fontSize: "14px",
        color: Colors.primary,
        marginBottom: "5px",
      },
      "& input": {
        width: "100%",
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        outline: "none",
        fontSize: "14px",
        backgroundColor: "#f9f9f9",
      },
    },
    "& .LoginBtn": {
      textAlign: "center",
      "& button": {
        padding: "10px 20px",
        fontSize: "16px",
        backgroundColor: Colors.primary,
        color: Colors.text,
        border: "none",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
      },
      "& button:disabled": {
        backgroundColor: "#ccc",
        cursor: "not-allowed",
      },
    },
  },
  "@media (min-width: 500px)": {
    padding: "5px",
    "& .LoginGroup button": {
      borderRadius: "10px",
    },
  },
  "@media (max-width: 300px)": {
    "& .LoginCard": {
      padding: "20px",
    },
  },
}));

export const LoginFooter = styled(Box)(() => ({
  backgroundColor: "#f5f5f5",
  color: Colors.grayText,
  padding: "10px",
  position: "fixed",
  bottom: "0",
  left: "0",
  width: "100%",
  "& p": {
    margin: "0",
    fontSize: "10px",
    textAlign: "center",
    "& span": {
      color: Colors.primary,
    },
  },
}));

export const Error = styled(Typography)(() => ({
  color: "red",
  fontSize: "12px",
  marginTop: "5px",
}));

export const RequiredStar = styled("span")(() => ({
  color: "#d9534f",
  marginLeft: "2px",
}));

export const LoginDivider = styled(Box)(() => ({
  width: "100%",
  fontSize: "13px",
  fontWeight: 500,
  position: "relative",
  marginTop: "55px",
  textAlign: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    left: "0",
    top: "50%",
    width: "100%",
    height: "1px",
    backgroundColor: "rgb(201, 201, 201)",
  },
  "& span": {
    backgroundcolor: Colors.text,
    position: "relative",
    zIndex: 1,
    padding: "0 10px",
  },
}));

export const LoginGroup = styled(Box)(({ className }) => ({
  marginBottom: "15px",
  "& label, &.CheckBox a": {
    color: Colors.primary,
    fontSize: "13px",
    fontWeight: 600,
    marginBottom: "2px",
  },
  "& label": {
    position: "relative",
    display: "inline-block",
  },
  "&.CheckBox": {
    marginBottom: "0",
  },
  "&.CheckBox a": {
    display: "block",
  },
  "& input, & select": {
    width: "100%",
    fontSize: "13px",
    outline: "none",
    border: "none",
    backgroundcolor: Colors.text,
    padding: "10px",
    borderRadius: "10px",
    boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
    height: "39px",
    "&::placeholder": {
      color: "rgb(143, 142, 142)",
    },
    "& option:checked": {
      backgroundColor: "#E8F0FE",
    },
  },
  "& button": {
    border: "none",
    backgroundColor: Colors.primary,
    color: Colors.text,
    padding: "12px 30px",
    borderTopLeftRadius: "10px",
    borderBottomLeftRadius: "10px",
    textTransform: "uppercase",
  },
  "& .PasswrdInpt": {
    position: "relative",
    "& button": {
      border: "none",
      background: "transparent",
      position: "absolute",
      padding: "0",
      top: "10px",
      right: "10px",
      "& img": {
        width: "18px",
      },
    },
  },
  "&.signUp": {
    textAlign: "center",
    "& p": {
      fontSize: "13px",
    },
    "& a": {
      color: "orangered",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  "&.LoginBtn": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    right: "0",
    position: "static",
    textAlign: "center",
    "& button": {
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#007BFF",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
    "& button:hover": {
      backgroundColor: Colors.hover,
    },
  },
}));

